module.exports = __webpack_public_path__ + "static/facebook_logo-1f012f7dc3328eb585163c56049cfa34.png";